import React from 'react';
import { Link } from 'react-router-dom';
import priorityImg from '../../assets/about/priority.png';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Priority.scss';

const Priority = () => {
    return (
      <section
        className="priority-section emergency-section"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="priority-img">
                <img src={priorityImg} alt="Emergency" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="priority-text">
                <SectionTitle
                  subTitle="OUR PRIORITY"
                  title="Our clients are our priority"
                  description="We are committed to delivering top-quality dental care with compassion, precision, and personalized attention for a healthier, brighter smile."
                />

                <div className="theme-btn">
                  <Link to="/contact">Book an appointment</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Priority;